import {
  EstadosAgendamientoEnumChoice,
  ROUTER_PATHS,
} from "@/shared";
import {
  AproveRecoordinacionData,
  useUpdateAgendamiento,
} from "@/shared/actions/erp";
import {
  CustomButtunsRejectConfirm,
  LoaderComponent,
  SingleFormBoxScene,
} from "@/shared/components/ui";
import {
  Agendamiento,
  AlertSeverityEnum,
  ErrorMessagesForm,
} from "@/shared/interfaces";
import {
  agendamientoFormSchemaMinified,
  handleErrorForm,
} from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import RejectAgendaModal from "@/erp/noc/agendamientonoc/shared/components/forms/RejectAgendaModal";
import AgendamientoSingleSoportePymes from "./AgendamientoSingleSoportePymes";
import { SaveFormDataAgendamiento } from "@/erp/operaciones/agendamiento/shared/interface/SaveFormDataAgendamiento.interface";
import { useFlotasStore } from "@/store/erp";
import { Typography } from "@mui/material";

function getEstadoAgendamiento(
  {
    solicitar_tecnico, isRejecting,
  }: {
    solicitar_tecnico: boolean,
    isRejecting: boolean,
  }
): EstadosAgendamientoEnumChoice {

  if (solicitar_tecnico) {
    return EstadosAgendamientoEnumChoice.PENDIENTE_TECNICO
  }

  if (isRejecting) {
    return EstadosAgendamientoEnumChoice.PRERECHAZADO;
  }

  return EstadosAgendamientoEnumChoice.RECORDINADO;
}


export interface SaveAgendamientoSoportePymesProps {
  title: string;
  agendamiento?: Agendamiento;
}


const SaveAgendamientoSoportePymes: React.FC<SaveAgendamientoSoportePymesProps> = ({
  title,
  agendamiento,
}) => {
  const navigate = useNavigate();
  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.soportePymes.preagendamientoNav;


  ///* local state --------------------
  const [openRechazoModal, setOpenRechazoModal] = useState(false);
  const [shrink] = useState(true);

  ///* global state --------------------
  const setAlert = useUiStore((s) => s.setAlert);

  ///* form --------------------
  const form = useForm<SaveFormDataAgendamiento>({
    resolver: yupResolver(agendamientoFormSchemaMinified) as any,
  });

  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = form;

  ///* mutations --------------------
  const updateAgendamientoMutation =
    useUpdateAgendamiento<AproveRecoordinacionData>({});

  ///* handlers --------------------

  const onSave = async (data: SaveFormDataAgendamiento) => {

    if (!isValid) return;

    const dataForm = {
      celular: data.celular!,
      celular_2: data.celular_2!,
      email: data.email!,
      direccion: data.direccion!,
      coordenadas: data.coordenadas!,
      es_pyme: true,
      // estado llamada ----
      estado_llamada: data.estado_llamada!,
      //fecha_hora_llamada: data.fecha_hora_llamada!,
      nap: data.nap,
      distancia: data.distancia,
      observaciones: {
        ...agendamiento?.preventa_data?.observaciones,
        observacion_llamada: data.observacion_llamada!,
        observacion_rechazo: data.observacion_rechazo || "",
        observacion_tecnico_adicional: data.observacion_tecnico_adicional || "",
      },
      pais: data.pais!,
      ciudad: data.ciudad!,
      provincia: data.provincia!,
      zona: data.zona!,
      sector: data.sector!,
      estado_agendamiento: getEstadoAgendamiento({
        solicitar_tecnico: data.solicitar_tecnico ?? false,
        isRejecting: data.isRejecting!,
      }),
      motivo_rechazo: data.motivo_rechazo || null,
      user_gestionando: null,
      flota: data.flota,
      solicitar_tecnico: data.solicitar_tecnico,
      ///* Cambio de flota y hora de instalacion
      hora_instalacion: data.hora_instalacion!,
      fecha_instalacion: data.fecha_instalacion,
      fecha_tecnico_adicional: data.fecha_tecnico_adicional,
      hora_tecnico_adicional: data.hora_tecnico_adicional,
      fecha_instalacion_original: agendamiento?.fecha_instalacion!,
      hora_instalacion_original: agendamiento?.hora_instalacion!,

    };


    ///* upd
    if (agendamiento && agendamiento?.id_agendamiento) {


      const resp = await updateAgendamientoMutation.mutateAsync({
        id: agendamiento.id_agendamiento!,
        data: dataForm as any,
      });

      if (resp.code === 200) {
        navigate(returnUrlAgendamientosPyLPage);
      }


      return;
    }
  };

  const onCancel = async (_agendamiento: Agendamiento) => {
    navigate(returnUrlAgendamientosPyLPage);
  };

  const { isLoadingFlotas, getFlotaAdicional } = useFlotasStore();

  ///* effects --------------------

  useEffect(() => {
    if (!agendamiento?.id_agendamiento) return;

    if (agendamiento.flota_adicional) {
      console.log('consultar flota adicional');

      getFlotaAdicional({
        codigo: agendamiento.flota_adicional
      })
    }

    const {
      preventa_data,
      prospecto_data,
      pais_data,
      provincia_data,
      ciudad_data,
      zona_data,
      sector_data,
      plan_data,
      flota_data,
      trazo_venta_data,
      preagendamiento_data,
      ...rest
    } = agendamiento;

    reset({
      ...prospecto_data,
      ...preventa_data,
      //...preagendamiento_data,
      ...rest,
      nacionalidad: pais_data?.nacionalidad!,
      observacion_1: preventa_data?.observaciones.observacion_1 || "",
      observacion_2: preventa_data?.observaciones.observacion_2 || "",
      es_referido: !!preventa_data?.tipo_referido ? "SI" : "NO",
      planLabel: plan_data?.nombre!,
      velocidad_internet: preventa_data?.velocidad
        ? `${preventa_data?.velocidad} ${plan_data?.unidad}`
        : "",
      isRejecting: false,
      //flota: rest.flota || "",
      flota: agendamiento.flota_adicional ?? flota_data?.codigo ?? "",
      observacion_llamada:
        agendamiento.observaciones?.observacion_llamada || "",
      observacion_rechazo:
        agendamiento.observaciones?.observacion_rechazo || "",
    } as unknown as SaveFormDataAgendamiento);
  }, [agendamiento, reset]);

  if (isLoadingFlotas)
    return <LoaderComponent />

  return (
    <>
      <SingleFormBoxScene
        titlePage={title}
        showCustomBtns={true}
        showActionBtns={false}
        num_referencia={agendamiento?.numero_referencia}
        customBtns={
          <CustomButtunsRejectConfirm
            onCancel={() => onCancel(agendamiento!)}
            onConfirm={() => {
              handleSubmit(onSave, (err) => {
                if (err?.estado_llamada || err?.observacion_llamada)
                  return setAlert(
                    true,
                    "El estado de llamada y su observación son requeridos",
                    AlertSeverityEnum.error
                  );
                handleErrorForm(err as ErrorMessagesForm);
              })();
            }}
            rejectTextBtn="Enviar a Gestión Ventas"
            showRejectBtn={true}
            onReject={() => {
              setOpenRechazoModal(true);
              form.reset({
                ...form.getValues(),
                isRejecting: true,
              });
            }}
            sxContainer={{
              pt: 5,
            }}
          />
        }
        additionalNoteText={
          <Typography>Punto de Enlace: <b>{
            agendamiento?.preagendamiento_data?.nombre_pyme_enlace
          }</b></Typography>
        }
      >
        <AgendamientoSingleSoportePymes
          form={form}
          shrink={shrink}
          agendamiento={agendamiento!}
        />

      </SingleFormBoxScene>

      <RejectAgendaModal
        open={openRechazoModal}
        onClose={() => {
          setOpenRechazoModal(false);
        }}
        agendamiento={agendamiento!}
        form={form}
        onConfirm={() => {
          handleSubmit(onSave, (err) => {
            if (err)
              return setAlert(
                true,
                "Revise que todos los campos se encuentren correctos.",
                AlertSeverityEnum.error
              );
            handleErrorForm(err);
          })();
        }}
      />

    </>
  )

};

export default SaveAgendamientoSoportePymes;
